// Expense  Getters

export const getExpenseList = state => {
  return state.expenseList
}

export const getExpenseInfo = state => {
  return state.expenseInfo
}

export const getDateFilter = state => {
  return state.dateFilter
}
